exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb10[data-v-270ae901] {\r\n\tmargin-bottom: 10px;\n}\n.colBlue[data-v-270ae901]{\r\n\tcolor: blue;\n}\n.colBlack[data-v-270ae901]{\n  color: black;\n}\n.colRed[data-v-270ae901]{\n  color: red;\n}\r\n", ""]);

// exports
